import { message } from "antd";
// import axios from "axios";
import Cookies from "js-cookie";
import { DataTableAction } from "../../table/action/data_table_action";
import { Tools, axios } from "../../../config";
import { ShopLogic } from "../../../logic/shop_logic";

export class ChooseAction extends DataTableAction {
    async delRow(id) {
       
    }
    delSelectList({ dispatch, selectList }: { dispatch: any; selectList: any; }) {
       
    }
    async loadPage({ dispatch, pageIndex, pageSize, search }) {

        const { keywords, typeId, statusId, areaId } = search;
        const params = {
            pageIndex,
            pageSize,
            seacherName: keywords,
            shopType: typeId,
            status: statusId,
            provincialCapital: (areaId && areaId.length >= 1) && areaId[0],
            city: (areaId && areaId.length >= 2) && areaId[1],
            district: (areaId && areaId.length >= 3) && areaId[2],
        };
        if ((areaId && areaId.length < 1)) {
            delete params.provincialCapital;
        }
        if ((areaId && areaId.length < 2)) {
            delete params.city;
        }
        if ((areaId && areaId.length < 3)) {
            delete params.district;
        }

        // 档案列表
        const r = await new ShopLogic().getShopAndChid();
        if (r.data.statusCode == 200) {
            const dataList = r.data.data || [];
            let list = []
            list = dataList.length > 0?dataList.map((v, i) => {
                v.key = i + 1;
                return v;
            }):[]

            this.setPaging({ dispatch, pageIndex, total: list.length, dataList: list, pageSize });
        }

    }
    setCondition(method: "Keywords" | "Area" | "Status" | "Type", value, dispatch) {
        if ("Keywords" == method) {
            dispatch({ type: "SetSearch", payload: { keywords: value } });
        }
        else if ("Area" == method) {
            dispatch({ type: "SetSearch", payload: { areaId: value } });
        }
        else if ("Status" == method) {
            dispatch({ type: "SetSearch", payload: { statusId: value } });
        }
        else if ("Type" == method) {
            dispatch({ type: "SetSearch", payload: { typeId: value } });
        }
    }
}
export const chooseAction = new ChooseAction();